<template>
    <div class="flex flex-column gap-2">
        <label v-if="props.label" :for="props.label" class="font-bold">{{ props.label }}:</label>
        <div>
            <Tag :style="props.style" :value="tagData?.name" class="p-2" :severity="tagData?.severity" />
        </div>
    </div>
</template>

<script setup>
import { computed, defineProps } from 'vue';

import { getAllProgress, getAllPriorities } from '../../product/ams/constants';
const props = defineProps({
    id: {
        type: [String, Number],
    },
    label: {
        type: String,
    },
    entity: {
        type: String,
    },
    style: {
        type: String,
        default: 'font-size: 0.8rem',
    },
});

const currentArray = computed(() => {
    return props.entity == 'progress' ? getAllProgress() : getAllPriorities();
});

const tagData = computed(() => {
    return currentArray.value?.find((entity) => entity.id == props.id);
});
</script>
